import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-greencampuspolicy',
    templateUrl: './greencampuspolicy.component.html',
    styleUrls: ['./greencampuspolicy.component.scss']
})
export class GreencampuspolicyComponent implements OnInit {

    constructor(private meta: Meta,
                private titles: Title) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Green Campus Policy: Fostering Sustainability');
        this.meta.updateTag({
            name: 'description',
            content: `Learn about ARNI Green Campus Policy, committed to creating an eco-friendly environment through sustainable practices, green initiatives, and environmental responsibility.`
        });
    }

}
